import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { mapCustomerRecordSnCodes } from './snCodeWire';

/**
 * 停用客戶。
 * `POST /crm/customer/{id}/deactivate`；body `{ updatedAt }`。
 *
 * @param {string} id
 * @param {{ updatedAt?: string }} [payload]
 */
export async function deactivateCustomer(id, payload = {}) {
  const { data: raw } = await request.post(
    `/crm/customer/${id}/deactivate`,
    keysToSnake(payload),
  );
  const parsed = parseVer4DetailResponse(raw);
  return { ...parsed, data: mapCustomerRecordSnCodes(parsed.data) };
}
